import styled from "@emotion/styled";
import { timelineColors } from "../theme/config";

export const ToolboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-right: 1px solid ${timelineColors.border};
  gap: 10px;
`;

export const BottomWrapper = styled.div`
  width: 100%;
  align-self: center;
  border-top: 1px solid ${timelineColors.border};
  height: 100%;
  background-color: #fff;
`;

export const ToolboxButton = styled.button<{ active: boolean }>`
  border: none;
  padding: 10px 10px;
  background-color: ${({ active }) => (active ? "#f4f4f4" : "#fff")};
  color: ${({ active }) => (active ? "grey" : "grey")};
  border-radius: 8px;
  width: 45px;
  height: 45px;
`;

export const ButtonIcon = styled.span`
  display: block;
  font-size: 16px;
`;

export const ContentWrapper = styled.div<{ height: number }>`
  display: inline-flex;
  min-height: ${({ height }) => height}px;
  border-top: 1px solid ${timelineColors.border};
`;

export const PlayerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;

  overflow: auto;
  padding: 0px 0px;
`;

export const ErrorWrapper = styled.div`
  position: absolute;
  top: 80px;
  left: 20px;
  right: 20px;
`;
